import { Button, Card, Heading, MessagePanel } from '@dittolive/anvil'
import paths from 'paths/link'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppManagementContext } from 'scenes/appManagement/context'

import DeleteAppModal from './DeleteAppModal'

/** Determines the redirection path based on the existence of a user ID or organization slug
 in the current pathname. */
const getRedirectionPath = (
  userId: string | null,
  organizationSlug: string | undefined,
) => {
  if (!!userId) {
    return paths.userApps({ userId })
  }

  if (!!organizationSlug) {
    return paths.organizationManagement({ slug: organizationSlug })
  }

  return paths.gettingStarted()
}

const DeleteAppSection = () => {
  const { appId } = useAppManagementContext()

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const navigate = useNavigate()
  const params = useParams<{ userId: string; organizationSlug: string }>()

  const cautionText = 'a database'

  return (
    <>
      <DeleteAppModal
        isOpen={showConfirmationModal}
        onClose={(shouldRedirect) => {
          if (shouldRedirect) {
            navigate(
              getRedirectionPath(params.userId!, params.organizationSlug),
              { replace: true },
            )
          } else {
            setShowConfirmationModal(false)
          }
        }}
        appId={appId}
      />

      <Card className="shadow-none">
        <Card.Header>
          <Heading level={3}>Delete database</Heading>
          <p className="text-foreground-subtle text-base">
            Permanently delete your database and all associated data
          </p>
        </Card.Header>

        <Card.Body>
          <MessagePanel
            variant="danger"
            message={() => (
              <>
                Deleting {cautionText} permanently destroys any data related to
                it. This action is{' '}
                <span className="font-medium">not reversible</span>, so please
                double check the details and proceed with caution.
              </>
            )}
          />

          <Button
            variant="critical"
            className="mt-8"
            onClick={() => setShowConfirmationModal(true)}
            data-testid="deleteApp"
          >
            Delete database
          </Button>
        </Card.Body>
      </Card>
    </>
  )
}

export default DeleteAppSection
